"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * EMSX Rest API
 * EMSX Rest API for Vet lookups
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class SearchApi extends runtime.BaseAPI {
    /**
     * Search for the four nearest placement providers to this one
     */
    searchFourNearestProvidersApiSearchNearestProvidersPpLocationIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.ppLocationId === null || requestParameters.ppLocationId === undefined) {
                throw new runtime.RequiredError('ppLocationId', 'Required parameter requestParameters.ppLocationId was null or undefined when calling searchFourNearestProvidersApiSearchNearestProvidersPpLocationIdGet.');
            }
            if (requestParameters.radius === null || requestParameters.radius === undefined) {
                throw new runtime.RequiredError('radius', 'Required parameter requestParameters.radius was null or undefined when calling searchFourNearestProvidersApiSearchNearestProvidersPpLocationIdGet.');
            }
            const queryParameters = {};
            if (requestParameters.radius !== undefined) {
                queryParameters['radius'] = requestParameters.radius;
            }
            if (requestParameters.page !== undefined) {
                queryParameters['page'] = requestParameters.page;
            }
            if (requestParameters.size !== undefined) {
                queryParameters['size'] = requestParameters.size;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/search-nearest-providers/{pp_location_id}`.replace(`{${"pp_location_id"}}`, encodeURIComponent(String(requestParameters.ppLocationId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.PageAPILocationPageDistanceFromJSON(jsonValue));
        });
    }
    /**
     * Search for the four nearest placement providers to this one
     */
    searchFourNearestProvidersApiSearchNearestProvidersPpLocationIdGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.searchFourNearestProvidersApiSearchNearestProvidersPpLocationIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Search for full address and lat/lng from partial address
     */
    searchGeoLocationApiSearchGeoLocationPartialAddressGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.partialAddress === null || requestParameters.partialAddress === undefined) {
                throw new runtime.RequiredError('partialAddress', 'Required parameter requestParameters.partialAddress was null or undefined when calling searchGeoLocationApiSearchGeoLocationPartialAddressGet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/search-geo-location/{partial_address}`.replace(`{${"partial_address"}}`, encodeURIComponent(String(requestParameters.partialAddress))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.APIGeocodingLocationFromJSON(jsonValue));
        });
    }
    /**
     * Search for full address and lat/lng from partial address
     */
    searchGeoLocationApiSearchGeoLocationPartialAddressGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.searchGeoLocationApiSearchGeoLocationPartialAddressGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Search for all placement providers who are sponsored placements
     */
    searchSponsoredProvidersApiSearchSponsoredProvidersGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.page !== undefined) {
                queryParameters['page'] = requestParameters.page;
            }
            if (requestParameters.size !== undefined) {
                queryParameters['size'] = requestParameters.size;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/search-sponsored-providers/`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.PageAPILocationPageFromJSON(jsonValue));
        });
    }
    /**
     * Search for all placement providers who are sponsored placements
     */
    searchSponsoredProvidersApiSearchSponsoredProvidersGet(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.searchSponsoredProvidersApiSearchSponsoredProvidersGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Searches for surrounding vets from given city
     * Search for Placement Provider address by business Name
     */
    searchVetApiSearchVetPpNameGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.ppName === null || requestParameters.ppName === undefined) {
                throw new runtime.RequiredError('ppName', 'Required parameter requestParameters.ppName was null or undefined when calling searchVetApiSearchVetPpNameGet.');
            }
            const queryParameters = {};
            if (requestParameters.page !== undefined) {
                queryParameters['page'] = requestParameters.page;
            }
            if (requestParameters.size !== undefined) {
                queryParameters['size'] = requestParameters.size;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/search-vet/{pp_name}/`.replace(`{${"pp_name"}}`, encodeURIComponent(String(requestParameters.ppName))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.PageAPILocationPageFromJSON(jsonValue));
        });
    }
    /**
     * Searches for surrounding vets from given city
     * Search for Placement Provider address by business Name
     */
    searchVetApiSearchVetPpNameGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.searchVetApiSearchVetPpNameGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Searches for surrounding vets from given longitude and latitude values
     * Search for Placement providers by their longitude/latitude
     */
    searchVetLongLatApiSearchAreaLimitLongitudeLatitudeRadiusPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.longitude === null || requestParameters.longitude === undefined) {
                throw new runtime.RequiredError('longitude', 'Required parameter requestParameters.longitude was null or undefined when calling searchVetLongLatApiSearchAreaLimitLongitudeLatitudeRadiusPost.');
            }
            if (requestParameters.latitude === null || requestParameters.latitude === undefined) {
                throw new runtime.RequiredError('latitude', 'Required parameter requestParameters.latitude was null or undefined when calling searchVetLongLatApiSearchAreaLimitLongitudeLatitudeRadiusPost.');
            }
            if (requestParameters.radius === null || requestParameters.radius === undefined) {
                throw new runtime.RequiredError('radius', 'Required parameter requestParameters.radius was null or undefined when calling searchVetLongLatApiSearchAreaLimitLongitudeLatitudeRadiusPost.');
            }
            if (requestParameters.aPIFilters === null || requestParameters.aPIFilters === undefined) {
                throw new runtime.RequiredError('aPIFilters', 'Required parameter requestParameters.aPIFilters was null or undefined when calling searchVetLongLatApiSearchAreaLimitLongitudeLatitudeRadiusPost.');
            }
            const queryParameters = {};
            if (requestParameters.page !== undefined) {
                queryParameters['page'] = requestParameters.page;
            }
            if (requestParameters.size !== undefined) {
                queryParameters['size'] = requestParameters.size;
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/api/search-area-limit/{longitude}/{latitude}/{radius}`.replace(`{${"longitude"}}`, encodeURIComponent(String(requestParameters.longitude))).replace(`{${"latitude"}}`, encodeURIComponent(String(requestParameters.latitude))).replace(`{${"radius"}}`, encodeURIComponent(String(requestParameters.radius))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.APIFiltersToJSON(requestParameters.aPIFilters),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.PageAPILocationPageDistanceFromJSON(jsonValue));
        });
    }
    /**
     * Searches for surrounding vets from given longitude and latitude values
     * Search for Placement providers by their longitude/latitude
     */
    searchVetLongLatApiSearchAreaLimitLongitudeLatitudeRadiusPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.searchVetLongLatApiSearchAreaLimitLongitudeLatitudeRadiusPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.SearchApi = SearchApi;
